export default "__VITE_ASSET__DnCmb37n__"